import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Item } from '../../../../../../../components/SearchForm/components/DestinationWidget/components/BlockLinks/PromotionItems/components/Item/index.js';
import { LabelMediumBold, Stack } from '../../../../../../../primitives/index.js';
export const PromotionItems = ({
  item,
  onSelectKeyword
}) => {
  return _jsxs(Stack, {
    "data-testid": "Promo-Items",
    children: [item.headline && _jsx(LabelMediumBold, {
      as: item.headline.tag,
      children: item.headline.text
    }), item.links?.map((item, index) => _jsx(Item, {
      item: item,
      onSelectKeyword: onSelectKeyword
    }, index))]
  });
};